const message = {
    upload: "上传",
    loadingText: "正在上传",
    listText: "列表",
    previewText: "预览",
    uploadUser: "上传人",
    uploadTime: "上传时间",
    totalCount: "共{count}份",
    dragText: "拖拽上传",
    uploadFile: "上传文件",
    dragTitle: "将文件拖拽到这里上传",
    dragTips: "支持文件格式：{accept}，单个文件大小{size}M以内",
    uploading: "正在上传",
    documentName: "文件名称",
    editDocumentName: "修改文件名称",
    documentTips: "请勿修改文件扩展名，这有可能导致文件不能正确预览",
    successDelete: "删除{name}成功",
    successEditFileName: "修改成功",
};

export default message;
